export default {
    file: 2000,
    sandbox: 5000
};
